/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Geofences Draw Icon component.
 */
export const GeofencesDrawIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 25 25' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M18.1099 17.4628C15.6893 19.8834 12.091 19.2219 10.2309 17.362C9.78705 16.9182 9.32979 16.2033 8.89814 15.2932C8.46982 14.3901 8.08036 13.3241 7.76152 12.2037C7.17222 10.1329 6.83848 7.92789 6.91285 6.26581C8.57493 6.19144 10.7799 6.52518 12.8508 7.11448C13.9712 7.43332 15.0371 7.82277 15.9402 8.25109C16.8503 8.68275 17.5652 9.14 18.009 9.58382C19.869 11.444 20.5304 15.0423 18.1099 17.4628Z' stroke={iconColor} />
      <circle cx='13.8674' cy='13.2202' r='1.5' transform='rotate(135 13.8674 13.2202)' fill={iconColor} />
      <path d='M14.2207 13.5742L7.17594 6.52945' stroke={iconColor} />
    </svg>
  );
};

export default GeofencesDrawIcon;
